module.exports = __webpack_public_path__ + "static/media/affiliationsActive.18038953.svg";